export default "__VITE_ASSET__$jyI9C6c__"